import { render, staticRenderFns } from "./PaymentConfirmation.vue?vue&type=template&id=5445b877&scoped=true"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=js"
import style0 from "./PaymentConfirmation.vue?vue&type=style&index=0&id=5445b877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445b877",
  null
  
)

export default component.exports